import Kfit from 'integrations/Kfit';

export default (id, params) =>
  Kfit.post(`/v9/companies/${id}/accounts/add_business_info`, params);
